import React from "react";
import "./style/milestone.css";

function Milestone() {
  const milestones = [
    {
      year: "2019",
      text: "EDC began its journey as an agency connecting brands with models, makeup artists, and photography services for visual promotion needs."
    },
    {
      year: "2020",
      text: "Expanded the portfolio by adding a new category: Kids Models."
    },
    {
      year: "2021",
      text: "Recruited the 2nd batch of models and supported major companies such as BCA and Privy in executing campaigns by providing talents and production teams."
    },
    {
      year: "2022",
      text: "Organized a Brand Activation event at Braga with 10 brand partners."
    },
    {
      year: "2023",
      text: "Launched EDC Liveboks, a live shopping service and studio at The Hallway Kosambi."
    },
    {
      year: "2025",
      text: "Established EDC Workss, with a passion for making brands recognized and connected."
    }
  ];

  const networks = [
    { number: "100+", label: "Models" },
    { number: "100+", label: "Live Hosts" },
    { number: "300+", label: "Influencers (Nano to Mega)" },
    { number: "50+", label: "In-house Content Creators" },
    { number: "50+", label: "Certified Makeup Artists" },
    { number: "50+", label: "Photographers & Videographers" },
  ];

  return (
    <section className="milestone-section" id="milestone">
      <div className="milestone-header">
        <h2>EDC <span className="highlight">Milestones</span></h2>
                <hr className="whyus-hr" data-aos="zoom-in" data-aos-delay="200" />

      </div>

      <div className="timeline">
        {milestones.map((item, index) => (
          <div
            className={`timeline-item ${index % 2 === 0 ? "left" : "right"}`}
            key={item.year}
          >
            <div className="timeline-content">
              <h3>{item.year}</h3>
              <p>{item.text}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="network-section">
        <h2>Our <span className="highlight">Network</span></h2>
        <div className="network-grid">
          {networks.map((net, idx) => (
            <div className="network-card" key={idx}>
              <h3>{net.number}</h3>
              <p>{net.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Milestone;
